import z from 'zod';

interface translationMappings {
	addressRequired: string;
	cityRequired: string;
	zipCodeRequired: string;
	max30Chars: string;
	stateRequired: string;
}

export const addressForm = {
	address: {
		name: 'address',
		label: 'Address',
		schema: z.string().trim().min(1, 'Address is required'),
	},
	zipCode: {
		name: 'zipCode',
		label: 'Zip Code',
		schema: z.coerce.string().regex(/^\d{5}$|^\d{5}-\d{4}$/, 'Please enter valid US zip code'),
	},
	city: {
		name: 'city',
		label: 'City',
		schema: z.string().trim().min(1, 'City is required').max(30, 'Max of 30 characters'),
	},
	state: {
		name: 'state',
		label: 'State',
		schema: z.string().regex(/^[a-z]+$/i, 'Valid State is required'),
	},
};

export const addressFormSchema = [
	{ name: addressForm.address.name, validation: addressForm.address.schema },
	{ name: addressForm.zipCode.name, validation: addressForm.zipCode.schema },
	{ name: addressForm.city.name, validation: addressForm.city.schema },
	{ name: addressForm.state.name, validation: addressForm.state.schema },
];

export default function generateAddressFormSchema(translations: translationMappings) {
	const addressFormConfiguration = {
		address: {
			name: 'address',
			label: 'Address',
			schema: z.string().trim().min(1, translations.addressRequired),
		},
		zipCode: {
			name: 'zipCode',
			label: 'Zip Code',
			schema: z.coerce.string().regex(/^\d{5}$|^\d{5}-\d{4}$/, translations.zipCodeRequired),
		},
		city: {
			name: 'city',
			label: 'City',
			schema: z.string().trim().min(1, translations.cityRequired).max(30, translations.max30Chars),
		},
		state: {
			name: 'state',
			label: 'State',
			schema: z.string().regex(/^[a-z]+$/i, translations.stateRequired),
		},
	};

	return [
		{ name: addressFormConfiguration.address.name, validation: addressFormConfiguration.address.schema },
		{ name: addressFormConfiguration.zipCode.name, validation: addressFormConfiguration.zipCode.schema },
		{ name: addressFormConfiguration.city.name, validation: addressFormConfiguration.city.schema },
		{ name: addressFormConfiguration.state.name, validation: addressFormConfiguration.state.schema },
	];
}
